import { createFileRoute } from "@tanstack/react-router";

import { DocumentTypesScreen } from "@/interactors/DocumentTypesScreen";
import { headWithCustomTitle, validateRoutePermission } from "@/utils/router";

export const Route = createFileRoute("/_authed/admin/document-types/")({
  component: DocumentTypesScreen,

  beforeLoad: ({ context }) =>
    validateRoutePermission({
      context,
      action: "list",
      subject: "document_types",
    }),
  head: () => headWithCustomTitle("main:documentTypes.title"),
});
